import { Injectable } from '@angular/core';
import {ApiService} from '../../services/api.service';
import {HttpClient} from '@angular/common/http';
import {OrganisationService} from './organisation.service';
import { switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})

export class AccessesService {

  constructor(
      private api: ApiService,
      private http: HttpClient,
      private organisationService: OrganisationService
  ) { }

  public getAccesses(strategiesToLoad = []) {
    const strategies = strategiesToLoad.join(',');
    return this.organisationService.getCurrentOrganisation().pipe(
      switchMap(organisation => this.api.getHeaders().pipe(
        switchMap(headers =>
          this.http.get(
            this.api.getHost() + '/mobile/access-control/organizations/' + organisation + '/accesses?strategies=' + strategies,
            { headers }
          )
        )
      ))
    );
  }
}
